import { PaymentInfo, BILLING_TYPE } from "../../../../../../../../types/payment.type";

type PropsConvertDeposit = {
  payments: PaymentInfo[];
  renterId: string;
}
export function ConvertDeposit({ renterId, payments }: PropsConvertDeposit) {
  const installmentPayments: string[] = [];
  let paymentId: string = '';
  let valueDeposit: number = 0;
  let typePaymnetDeposit: BILLING_TYPE = BILLING_TYPE.UNDEFINED;
  let depositInstallmentId = '';
  const today = new Date().toISOString().split('T')[0];

  const depositBilling = payments.filter(payment =>
    /^(caucao|caucao-facilitado)$/.test(payment.planId ?? "") && payment.status === "PENDING"
  );

  const installmentDeposit = payments.filter(payment =>
    payment.planId?.startsWith("caucao-facilitado-") && payment.status === "PENDING"
  );
  const depositInstallment = payments.filter(payment =>
    payment.planId?.startsWith("caucao") && payment.status === "PENDING"
  );


  for (let i = 0; i < depositBilling.length; i++) {
    if (depositBilling[i].status === "PENDING") {
      paymentId = depositBilling[i]._id;
      valueDeposit += depositBilling[i].value;
      typePaymnetDeposit = depositBilling[i].billingType ?? typePaymnetDeposit;
    }
  }

  for (let i = 0; i < installmentDeposit.length; i++) {
    if (installmentDeposit[i].status === "PENDING") {
      installmentPayments.push(installmentDeposit[i]._id);
    }
  }

  if (depositInstallment && depositInstallment.length > 0) {
    for (let i = 0; i < depositInstallment.length; i++) {
      const history = depositInstallment[i]?.history;
      if (history && history.length > 0) {
        depositInstallmentId = history[0].data.installment;
      }
    }
  }

  const initialValues = {
    depositInstallmentId: depositInstallmentId,
    installmentDeposit: installmentDeposit.length ?? 0,
    installmentOption: '',
    installmentPayments: installmentPayments,
    newValueDeposit: installmentDeposit.length > 0 ? 0 : 400,
    paymentId: paymentId,
    paymentDate: today,
    paymentType: installmentDeposit.length > 0 ? " " : typePaymnetDeposit,
    renterId: renterId,
    valueDeposit: valueDeposit,
    valueInstallment: "",
  };

  return {
    initialValues,
    installmentDeposit,

  }
}